import { requests } from 'api';
import { Location } from './types';

const apiBaseUrl = '/api/locations';

export const LocationsApi = {
  getAll: (): Promise<Location[]> => requests.get(apiBaseUrl),
};
